<template>
  <div class="columns is-multiline is-gapless">
    
    <div v-for="(layer, index) in layers" :key="layer._id"  :class="`column is-flex ${$common.clipartLayerWidthClass(layer.layer_width)} ${$common.clipartLayerAlignmentClass(layer.alignment)}`">
      <div class="clipart-layer mb-2" :style="clipartLayerStyles(index)">
        <div v-for="row_id in Math.ceil(layer.number/layer.number_row)" :key="`CLIPART_${index}_ROW_${row_id}`" :class="`has-text-centered is-flex`" >
          <div :style="rowStylesForLayer(layer.is_row_group_border, layer.row_styles)">
            <div v-for="(clipart,i) in ((row_id == Math.ceil(layer.number/layer.number_row)) ? (layer.number - (layer.number_row*(row_id-1))) : layer.number_row)" :key="`${i}`" :style="`z-index: ${500-row_id};${(layer.clipart_resize_type == 'W' && layer.clipart_width) ? 'width:'+layer.clipart_width+'px;' : ''}${(layer.clipart_resize_type == 'H' && layer.clipart_height) ? 'height:'+layer.clipart_height+'px!important' : ''}`" :class="`default-clipart ${layer.apply_border ? 'has-border' : ''} ${$common.clipartImageMargin(layer.image_margin)}`">
              <show-image :style="`${(layer.clipart_resize_type == 'W' && layer.clipart_width) ? 'width:'+layer.clipart_width+'px;' : ''}${(layer.clipart_resize_type == 'H' && layer.clipart_height) ? 'height:'+layer.clipart_height+'px!important' : ''}`" v-if="layer.clipart" :src="layer.clipart.file" />
              <show-image :style="`position:absolute;left:0;top:0;background:#ffffff87;${(layer.clipart_resize_type == 'W' && layer.clipart_width) ? 'width:'+layer.clipart_width+'px;' : ''}${(layer.clipart_resize_type == 'H' && layer.clipart_height) ? 'height:'+layer.clipart_height+'px!important;width:fit-content!important;' : ''}`" v-if="layer.overlay_clipart && layer.overlays && layer.overlays.includes(clipartRowColToNumber(index, row_id, i))" :src="layer.overlay_clipart.file" />
            </div>
          </div>
        </div>
      </div>        
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"

// Components
import ShowImage from "@/components/General/ShowImage"

export default {
  name: "show-clipart-layer",
  refs: ['custom_layout_outer_box'],
  components: {
    ShowImage
  },
  props: {
    layers : {
      type : Array,
    }
  },
  data() {
    return {  
    };
  },
  computed: {
    ...mapGetters(["getTeacherToken"]),
  },
  methods: {
    ...mapActions([""]),
    clipartLayerStyles(index){
      let style = {}
      const layer = this.layers[index]
      if(layer.is_layer_border){
        const border_color = layer.layer_border_color ? layer.layer_border_color : '#ccc'
        const border_width = layer.layer_border_width ? layer.layer_border_width : 1 
        style['border'] = `${border_width}px solid ${border_color}`
      }
      return style
    },
    clipartRowColToNumber(layer_index, row, col){
      let layer = this.layers[layer_index]
      let position = ((row-1)*layer.number_row) + (col + 1)
      return position
    },
    rowStylesForLayer(show_border, styles_obj){
      let styles = {}

      if(show_border && styles_obj){
        let border_color = styles_obj.border_color ? styles_obj.border_color : '#000'
        let border_width = styles_obj.border_width ? styles_obj.border_width : 1
        let border_style = `${border_width}px solid ${border_color}`
        styles['border'] = border_style
      }
      
      return styles
    }
  },
  async created(){
    
  },
};
</script>
<style scoped>
.clipart-layer{
  display: flex;
  flex-direction: column;
  float: left;
}
</style>